const SIDEBAR_WIDTH = 40;

window.timerResizeSidebar = 0;

window.initSidebar = function() {
    if ($("body").width() < 768) {
        expandSidebar();
    } else {
        collapseSidebar();
    }
};

window.expandSidebar = function() {
    $(".sidebar").css("width", "");
    $(".sidebar").find("span").show();
    $(".main").css('width', '');
}

window.collapseSidebar = function() {
    $(".sidebar").css("width", SIDEBAR_WIDTH+"px");
    $(".sidebar").find("span").hide();
    $(".main").css('width', $("body").width() - SIDEBAR_WIDTH);
}

window.resizeSidebar = function() {
    clearTimeout(timerResizeSidebar);
    timerResizeSidebar = setTimeout(function() {
        if ($("body").width() < 768) {
            expandSidebar();
        } else {
            collapseSidebar();
        }
    }, 1000);
}
